import React from 'react';

const NoPage = () => {
  return (
    <div className="page">
      <div className="main-content">
        <h1> 404 </h1>
      <p>There's nothing here.</p>
      </div>
    </div >
  );
};

export default NoPage;
